import Cookies from "js-cookie";

interface CookieOptions {
  domain?: string;
  SameSite?: string;
  Secure?: boolean;
}

class AuthCookies {
  private commonOptions: CookieOptions;

  constructor(private TokenKey: string , options?: CookieOptions) {
    this.TokenKey = TokenKey;
    this.commonOptions = options ||  {
      domain:
        import.meta.env.VITE_APP_ENV === "development"
          ? ".testdomain.com"
          : ".zhidiancloud.com",
      SameSite: import.meta.env.VITE_APP_ENV === "development" ? "lax" : "none",
      Secure: import.meta.env.VITE_APP_ENV === "development" ? false : true,
    };
  }

  private applyOptions(options?: CookieOptions): CookieOptions {
    return { ...this.commonOptions, ...options };
  }

  getToken() {
    return Cookies.get(this.TokenKey, this.applyOptions());
  }

  setToken(token: string) {
    return Cookies.set(this.TokenKey, token, this.applyOptions());
  }

  removeToken() {
    return Cookies.remove(this.TokenKey, this.applyOptions());
  }

  getTokenByKey(key: string) {
    return Cookies.get(key, this.applyOptions());
  }

  setTokenByKey(key: string, token: string) {
    return Cookies.set(key, token, this.applyOptions());
  }

  removeTokenByKey(key: string) {
    return Cookies.remove(key, this.applyOptions());
  }
}

export { AuthCookies };
